export enum ENDPOINTS {
  //AUTH
  SIGN_UP = '/v2/users/signup',

  //PAYWALL
  CREATE_STRIPE_CHECKOUT = '/v2/users/subscription/create-checkout-session',
  APPLY_PROMO_CODE = '/v2/users/accesscode',
  VALIDATE_PROMO_CODE = '/v2/users/accesscode/validate',
  VALIDATE_SUBSCRIPTION = '/user/payments/subscription/validate',
  GET_AVAILABLE_PLANS = '/v2/users/subscription/plans',
  CREATE_STRIPE_CUSTOMER = '/v2/users/subscription/customer',
  GET_COUPON_INFO = '/v2/users/subscription/coupon',

  //SUBSCRIPTION
  GET_BILLING_HISTORY = '/user/subscription/billing-history',
  GET_SUBSCRIPTION_INFO = '/user/subscription/customer-info',
  GET_SESSION_ID = '/user/subscription/create-checkout-session',
  CANCEL_SUBSCRIPTION = '/user/subscription/cancel',
  RESET_PASSWORD = '/user/auth/reset',

  //MULTI USER INVITATION
  VERIFY_INVITE = '/v2/users/invitations/verify',
}
